<div class="div-validations-password">
  <div class="div-validation-password" [ngClass]="validationLowerCase ? 'successv' : 'errorv'">
    <mat-icon class="icon-validation" [svgIcon]="validationLowerCase ? 'dhl-icon-check-validation' : 'dhl-icon-error-validation'"></mat-icon>
    <span class="text-validation">Una letra minúscula</span>
  </div>
  <div class="div-validation-password" [ngClass]="validationUpperCase ? 'successv' : 'errorv'">
    <mat-icon class="icon-validation" [svgIcon]="validationUpperCase ? 'dhl-icon-check-validation' : 'dhl-icon-error-validation'"></mat-icon>
    <span class="text-validation">Una letra mayúscula</span>
  </div>
  <div class="div-validation-password" [ngClass]="validationNumber ? 'successv' : 'errorv'">
    <mat-icon class="icon-validation" [svgIcon]="validationNumber ? 'dhl-icon-check-validation' : 'dhl-icon-error-validation'"></mat-icon>
    <span class="text-validation">Un número</span>
  </div>
  <div class="div-validation-password" [ngClass]="validationSpecialCharacters ? 'successv' : 'errorv'">
    <mat-icon class="icon-validation" [svgIcon]="validationSpecialCharacters ? 'dhl-icon-check-validation' : 'dhl-icon-error-validation'"></mat-icon>
    <span class="text-validation">Un caracter especial (Ej. !@#$^&*?-_=)</span>
  </div>
  <div class="div-validation-password" [ngClass]="validationLength ? 'successv' : 'errorv'">
    <mat-icon class="icon-validation" [svgIcon]="validationLength ? 'dhl-icon-check-validation' : 'dhl-icon-error-validation'"></mat-icon>
    <span class="text-validation">Debe ser de al menos 8 caracteres</span>
  </div>
</div>
